const resources = {
    showMore: 'Show More',
    viewing: 'Viewing',
    results: 'results'
};

export default function getResource(label) {
    return resources[label];
}
